import { RunnerCase } from '../../models/test-run.model';

/** Worauf das Reihenfolge-Element eines Falls zeigt: den Testfall oder bei einer Modul-Wurzel das Modul. */
export function rootIdOf(runnerCase: RunnerCase): string | null {
  return runnerCase.testCaseId ?? runnerCase.testModuleId ?? null;
}

export function moduleRootOf(cases: readonly RunnerCase[]): (RunnerCase & { testModuleId: string }) | null {
  const root = cases.find((runnerCase) => runnerCase.rootKind === 'MODULE' && !!runnerCase.testModuleId);
  return (root as (RunnerCase & { testModuleId: string }) | undefined) ?? null;
}
